// export type IAvailableRoles = 'ROLE_SUPER_ADMIN' | 'ROLE_ADMIN' | 'ROLE_USER';
export type IAvailableRolesLabel = 'Super Admin' | 'Admin' | 'User';

export const ROLES = {
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_USER: 'ROLE_USER',
} as const;
export type ROLES = (typeof ROLES)[keyof typeof ROLES];
